import React from "react";
import { FiCalendar } from "react-icons/fi";
import { Link } from "gatsby";

interface CardNewsProps {
  slug: string;
  title: string;
  date: string;
  body: string;
  image: string;
}

const mes = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

const CardNews: React.FC<CardNewsProps> = ({
  slug,
  title,
  date,
  body,
  image,
}) => {
  const dateConverted = new Date(date);

  return (
    <Link className="mt-4" to={`/noticia/${slug}`} style={{ display: "block" }}>
      <span className="tag is-primary is-light has-text-weight-bold mb-1">
        <FiCalendar className="mr-1" />
        {`${dateConverted.getDate()} de ${
          mes[dateConverted.getMonth()]
        }, ${dateConverted.getFullYear()}`}
      </span>
      <div>
        <div className="is-flex is-flex-direction-row m-0">
          <figure className="image has-radius">
            <img
              className="object-fit image-card-news"
              src={image || "/no-image.png"}
              alt="Imagem da notícia"
              loading="lazy"
            />
          </figure>
          <div className="column py-0 has-text-dark">
            <h6>{title}</h6>
            <div
              className="ellipsis"
              dangerouslySetInnerHTML={{ __html: body }}
            ></div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CardNews;
